import React from 'react'
import { Check, X } from 'lucide-react'

class CallNewLeads extends React.Component {

  render() {
    let sales_manager = this.props.sales_manager

    return(
      sales_manager ?
        <div>
          {(sales_manager.assignment_strategy == 'ask') ?
            <span title="You are seen as available to call new enquirers if prompted.">
              <Check className="mr-2 inline size-4"/>Call New Leads
            </span>
          :
            <span title="You are unavailable to call new enquirers.">
              <X className="mr-2 inline size-4"/>Call New Leads
            </span>
          }
        </div>
        : null
    )
  }
}

export default CallNewLeads
